import type { SVGProps } from 'react';

import { cn } from '@workspace/lib/utils/cn';

interface ModalPopupWarningIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ModalPopupWarningIcon = ({
  className,
  ...props
}: ModalPopupWarningIconProps) => {
  return (
    <svg
      viewBox='0 0 37 32'
      width='37'
      height='32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn(className)}
      aria-hidden='true'
      {...props}
    >
      <path
        d='M18.3333 6.65L30.8833 28.3333H5.78333L18.3333 6.65ZM18.3333 0L0 31.6667H36.6667L18.3333 0ZM20 23.3333H16.6667V26.6667H20V23.3333ZM20 13.3333H16.6667V20H20V13.3333Z'
        fill='currentColor'
      />
    </svg>
  );
};
